import { useAnalytics } from "@/src/sb/components/Analytics"
import { COMPLETED_PROFILE_DEMO_FORM_URL } from "@/src/sb/constants/configs"
import { useUser } from "@/src/sb/hooks/useUser"

type LicenceActionType = "get_licence" | "upgrade_licence"

const useRequestDemo = () => {
  const user = useUser()
  const analytics = useAnalytics()
  const userHasALicence = Boolean(user.data?.corporate_subscriber_licence)
  const type: LicenceActionType = userHasALicence
    ? "upgrade_licence"
    : "get_licence"

  return {
    loading: user.loading,
    url: COMPLETED_PROFILE_DEMO_FORM_URL,
    trackClickCorporateQuote: (
      props: {
        type?: LicenceActionType
      } & Record<string, any> = {}
    ) => {
      analytics?.clickCorporateQuote({ type, ...props })
      analytics?.trackRequestDemoClick({ type, ...props })
    }
  }
}

export default useRequestDemo
